export default function IconLogin(props) {
    return (
        <svg {...props} viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.2266 13.2378L12.4132 11.0512L10.2266 8.8645" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3.6665 11.0518H12.3534" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10.5 4.16675C14.2754 4.16675 17.3333 6.72925 17.3333 11.0001C17.3333 15.2709 14.2754 17.8334 10.5 17.8334" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}
